import * as Yup from 'yup';
import { checkAllowableSelections, setRequired } from './ArrayUtils';


const RSMulti = ({qObj}) => {
  let valObj = Yup.array();
  valObj = setRequired(valObj, qObj.is_required, qObj);
  valObj = checkAllowableSelections(valObj, qObj);
  return valObj;
};

export default RSMulti;